import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import SectionHead from "./SectionHead";

const POINTS = [
  "Ruhige Atmosphäre statt Partylärm",
  "Gepflegte Tische, warmes Licht, gute Musik",
  "Getränke und Snacks",
];

export default function Lounge() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="lounge" ref={ref} data-testid="lounge-section" className="relative overflow-hidden bg-[#1c1512]">
      <div className="grid lg:grid-cols-2">
        <div className="relative min-h-[60vh] overflow-hidden lg:min-h-[90vh]">
          <motion.img
            src="/images/lounge.jpg"
            alt="Die Vintage Billard Lounge mit mehreren Tischen und Bar"
            style={{ y }}
            className="absolute inset-0 h-[116%] w-full object-cover"
          />
        </div>
        <div className="flex flex-col justify-center px-6 py-20 md:px-16 lg:py-32">
          <SectionHead
            chapter="02"
            eyebrow="Die Lounge"
            title={
              <>
                Ein Ort zum
                <br />
                <span className="italic text-[#e3c988]">Abschalten.</span>
              </>
            }
          />
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-[#c9bda9] md:text-lg">
              Mit Vintage Billard möchten wir einen Ort schaffen, an dem man dem Alltag für eine
              Weile entfliehen, abschalten und einfach eine gute Zeit haben kann. In entspannter
              und gemütlicher Atmosphäre könnt ihr gemeinsam mit Freunden den Abend genießen, eine
              Runde Billard, Darts oder Kicker spielen und den Stress des Tages hinter euch lassen.
              Bei uns geht es darum, zusammenzukommen, Spaß zu haben und den Moment zu genießen.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <ul className="mt-10 space-y-4">
              {POINTS.map((point) => (
                <li key={point} className="flex items-center gap-4 text-sm text-[#f4ecdd] md:text-base">
                  <span className="h-1.5 w-1.5 rotate-45 bg-[#c9a24a]" />
                  {point}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
